/**
 * Height of the fixed Allen header rendered by `appLayoutOverride`.
 *
 * The Backstage sidebar is fixed to the top of the viewport, so it has to be
 * offset by this amount to sit below the header instead of underneath it.
 */
export const HEADER_HEIGHT = 72;

/**
 * Id of the wrapper around `SidebarPage` in `appLayoutOverride`.
 *
 * JSS class names are minified in production builds, so this id is the only
 * stable anchor the sidebar offset rules in `styles.css` can hang off.
 */
export const SIDEBAR_LAYOUT_ID = 'allen-sidebar-layout';
